import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {ButtonGroup} from 'shells/button-group/button-group';
import {Illustration} from 'shells/illustrations/illustration';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

import {useGetSessionUser} from '../../../core/use-get-session-user';
import {useGetInboxStatus} from '../../../setup/text-messaging/graphql/hooks/use-get-inbox-status';

type Props = {
    onClose: () => void;
};

export function SmsOnboarding(props: Props) {
    const {inboxStatus} = useGetInboxStatus();
    const {user} = useGetSessionUser();

    return (
        <div className='flex flex-dir-col pad-32 full-width full-height align-center justify-center border-box'>
            <StackLegacy spacing={16}>
                <Header>Introducing Nutshell SMS!</Header>
                <Subheader>
                    Your go-to messaging service for seamless communication across everything SMS.
                </Subheader>
                <div className='flex full-width justify-center'>
                    <Illustration src='conversation-bubbles' width={240} />
                </div>
                <BulletedList
                    bullets={[
                        'Send and receive messages at the ideal time, even when you’re unavailable with scheduled messaging!',
                        'Put your messages on pause with our snooze feature to deal with them later, helping you maintain focus.',
                        'Easily associate conversations with related leads for streamlined follow-up!',
                    ]}
                    size='big'
                />
                <Body>
                    Get started with Nutshell SMS by enrolling your business. To use this service,
                    you will need to purchase text credits. Check out our plans to maximize your
                    messaging capabilities.
                </Body>
                {Boolean(user && user.permissions.canAccessSetup) && (
                    <div className='flex align-center justify-center mt-32'>
                        <ButtonGroup>
                            {inboxStatus && inboxStatus.planStatus.status === 'NO_PLAN' && (
                                <Link
                                    // @ts-expect-error
                                    as={RoutedLink}
                                    size='big'
                                    variant='button-primary'
                                    to='/setup/billing/sales'
                                    onClick={props.onClose}
                                >
                                    Explore Nutshell plans
                                </Link>
                            )}
                            {inboxStatus && inboxStatus.status === 'NOT_STARTED' && (
                                <Link
                                    // @ts-expect-error
                                    as={RoutedLink}
                                    size='big'
                                    variant='button-primary'
                                    to='/inbox/settings/sms'
                                    onClick={props.onClose}
                                >
                                    Start your enrollment
                                </Link>
                            )}
                        </ButtonGroup>
                    </div>
                )}
            </StackLegacy>
        </div>
    );
}
